@if (data.header) {
  <h2 mat-dialog-title>{{data.header}}</h2>
}
<div mat-dialog-content>
  <p [innerHtml]="data.text"></p>
</div>
<div mat-dialog-actions>
  <button matButton [mat-dialog-close]="true" cdkFocusInitial>{{ data.buttons?.ok || 'OK'}}</button>
</div>